import { FileUpIcon, TagIcon } from "lucide-react";
import { Logo } from "@/components/brand/logo.tsx";
import { useI18n } from "@/i18n/index.tsx";

/** "What are we classifying?" with example chips that fill the composer and two tips. */
export function ClassifyEmptyState({ onExample }: { onExample: (text: string) => void }) {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center px-4 pt-[8vh] pb-8 text-center sm:pt-[12vh]">
      <span className="flex size-14 items-center justify-center rounded-2xl border bg-card text-primary shadow-sm dark:text-foreground">
        <Logo size={34} accent />
      </span>
      <h1 className="mt-5 text-2xl font-bold tracking-[-0.02em] sm:text-[28px]">{t.empty.title}</h1>
      <p className="mt-2 max-w-md text-[14px] leading-relaxed text-balance text-muted-foreground">{t.empty.subtitle}</p>

      <div className="mt-6 flex flex-col items-center gap-2">
        <span className="text-[11px] font-semibold tracking-[0.06em] text-muted-foreground uppercase">{t.empty.examplesLabel}</span>
        <div className="flex flex-wrap justify-center gap-2">
          {t.empty.examples.map((example) => (
            <button
              key={example}
              type="button"
              onClick={() => onExample(example)}
              className="rounded-full border bg-card px-3.5 py-1.5 text-[13px] font-medium text-foreground shadow-xs transition-colors hover:border-primary/40 hover:bg-primary-soft hover:text-primary-soft-foreground focus-visible:ring-[3px] focus-visible:ring-ring/35 focus-visible:outline-none"
            >
              {example}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid w-full gap-3 text-left sm:grid-cols-2">
        <div className="flex gap-3 rounded-xl border bg-card p-4">
          <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary-soft text-primary-soft-foreground">
            <TagIcon className="size-4" aria-hidden />
          </span>
          <div>
            <p className="text-[13px] font-semibold">{t.empty.tipArticleTitle}</p>
            <p className="mt-0.5 text-[12.5px] leading-relaxed text-muted-foreground">{t.empty.tipArticleText}</p>
          </div>
        </div>
        <div className="flex gap-3 rounded-xl border bg-card p-4">
          <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary-soft text-primary-soft-foreground">
            <FileUpIcon className="size-4" aria-hidden />
          </span>
          <div>
            <p className="text-[13px] font-semibold">{t.empty.tipAttachTitle}</p>
            <p className="mt-0.5 text-[12.5px] leading-relaxed text-muted-foreground">{t.empty.tipAttachText}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
